import * as React from 'react';
import { Button, Icon, Modal } from '../..';

type ModalProps = {
  onCloseModal: () => void;
  onRemoveItem: () => void;
  showArchive: boolean;
  deleteCb: () => Promise<unknown>;
  archiveCb?: () => Promise<unknown>;
};

function DeletePrompt({
  onCloseModal,
  onRemoveItem,
  showArchive,
  deleteCb,
  archiveCb,
}: ModalProps) {
  const [deleteStatus, setDeleteStatus] = React.useState<
    'IDLE' | 'LOADING' | 'RESOLVED' | 'REJECTED'
  >('IDLE');
  const [archiveStatus, setArchiveStatus] = React.useState<
    'IDLE' | 'LOADING' | 'RESOLVED' | 'REJECTED'
  >('IDLE');

  const handleOnDeleteClicked = async () => {
    setDeleteStatus('LOADING');

    onRemoveItem();

    await deleteCb();

    onCloseModal();

    setDeleteStatus('RESOLVED');
  };

  const handleOnArchiveClicked = async () => {
    setArchiveStatus('LOADING');
    onRemoveItem();

    await archiveCb?.();

    onCloseModal();

    setArchiveStatus('RESOLVED');
  };
  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-md bg-white tablet:w-[500px]">
        <div className="flex flex-col p-5">
          <h3
            className="text-pos-black text-xl font-semibold mb-2 
            inline-flex whitespace-pre"
          >
            Delete!
          </h3>
          <p className="text-pos-black text-base mb-2 font-normal">
            Are you sure you want perform this action?
            {showArchive && (
              <span
                className="inline-flex items-center rounded-[4px] text-sm pl-2 pr-1 py-2 mt-4 font-light 
              bg-[#ddf4ff] text-pos-blue leading-normal"
              >
                <Icon id="iconHintHelp" className="w-[17px] h-[17px] mr-2" />{' '}
                {`Don't want to loss it forever? click on ARCHIVE and later
              restore.`}
              </span>
            )}
          </p>

          <div className="mt-4 text-center flex flex-row ml-auto space-x-4">
            {showArchive && (
              <Button
                label="Archive"
                onClick={handleOnArchiveClicked}
                type="button"
                disabled={
                  archiveStatus === 'LOADING' || deleteStatus === 'LOADING'
                }
                loading={archiveStatus === 'LOADING'}
                className="!bg-[#f6f8fa] min-w-[150px] h-[40px] items-center justify-center
              !text-pos-black text-xbase border border-[rgba(27,31,36,0.15)]
                shadow-[0_1px_0_rgba(27,31,36,0.04),inset_0_1px_0_rgba(255,255,255,0.25)] shrink-0 font-medium"
              />
            )}
            <Button
              label="Yes! Delete"
              onClick={handleOnDeleteClicked}
              type="button"
              disabled={
                archiveStatus === 'LOADING' || deleteStatus === 'LOADING'
              }
              loading={deleteStatus === 'LOADING'}
              className="!bg-pos-red border border-[rgba(27,31,36,0.15)] min-w-[150px]  h-[40px]
                    items-center justify-center text-white text-xbase
                    shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

DeletePrompt.defaultProps = {
  archiveCb: undefined,
};

export default DeletePrompt;
